import React from 'react';
import { Autocomplete, Box, TextField, styled } from '@mui/material';
import { useSearchParam } from 'helpers/useSearchParam';
import { useJobsContext } from 'components/JobList';

const FilterField = styled(Box)({
  minWidth: 160,
  flex: '1 1 160px',
  maxWidth: 240
});

export default function SelectJobType() {
  const { onTypeSelectChange, jobTypes } = useJobsContext();
  const [type] = useSearchParam('type');

  const options = jobTypes.map((jobType) => ({
    value: jobType,
    label: jobType
  }));

  const selected = options.find((option) => option.value === type) || null;

  return (
    <FilterField>
      <Autocomplete
        clearOnEscape
        getOptionLabel={(option) => option.label || ''}
        isOptionEqualToValue={(option, selectedValue) =>
          option.value === selectedValue.value
        }
        onChange={(_event, next) => onTypeSelectChange(next?.value || '')}
        options={options}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Type"
            placeholder="Search type"
            size="small"
          />
        )}
        size="small"
        value={selected}
      />
    </FilterField>
  );
}
